import BaseService from "../baseService";
class Bloqueios extends BaseService {
    constructor(id) {
        const resource = "bloqueio-entrada-nf";
        let relationship = {
            logs:"logs"
        };
        super(id, relationship, resource);
    }
}

export default (id) => new Bloqueios(id);
